<template>
  <div class="half_circle">
      <div class="halfPieEcharts" ref="halfPie_statistics" style="height:100%;width:100%;"></div>
  </div>
</template>

<script>
  import EChart from 'echarts'

  export default {
    props:{
        col:{
            type:Array,
            default:()=>[]
        },
        values:{
            type:[Number,String],
            default:0
        }
    },
    watch:{
        values(newVal){
            this.showVal = newVal;
            setTimeout(()=>{
                this.initData();
            },2000)
        }
    },
    data() {
      return {
        halfPie_statistics: {
          option: {},
          chart: null,
          element: {},
        },
        showVal:0,
        chartArray:['halfPie_statistics'],
        // col:[0.45, '#00ff00']
      }
    },
    components:{
    },
    mounted() {
      this.$nextTick(()=>{
        setTimeout(()=>{
          window.addEventListener('resize', this.onWindowResize)
          this.onWindowResize();
        },1500);
      });
    },
    beforeDestroy(){
        // this.halfPie_statistics.chart.clear();
        window.removeEventListener('resize',this.onWindowResize);
    },
    destory() {
    //   window.onresize = null;
    },
    methods: {
        //根据页面调整
        onWindowResize(){
            // let pageHeight = document.documentElement.clientHeight; //页面总高度
            // let halfPieStyle = document.querySelectorAll(".isLine")[0].clientHeight;
            // let titleHeight = document.querySelectorAll(".realTime_title")[0].clientHeight;

            //  1 标题   2 echrts
            // let  realTime_statistics =  document.querySelectorAll(".realTime_statistics")[0].clientHeight;
            // document.querySelectorAll(".half_circle")[0].style.height =  halfPieStyle - titleHeight- 17 - 20 + 'px';
            // document.querySelectorAll(".halfPieEcharts")[0].style.height = halfPieStyle - titleHeight - 17 - 20 + 'px';
            // document.querySelectorAll(".halfPieEcharts")[1].style.height = halfPieStyle - titleHeight - 17 - 20 + 'px';
            // document.querySelectorAll(".halfPieEcharts")[2].style.height = halfPieStyle - titleHeight - 17 - 20 + 'px';
            // if(JSON.stringify(this.values) !== "{}")this.disposeAllChart();
            // this.initData();
            if(!document.querySelectorAll(".right_wrap") && !document.querySelectorAll(".realTime_title") && !document.querySelectorAll(".realTime_title")[0])return false;
            let halfPieStyle = document.querySelectorAll(".right_wrap")[2].clientHeight;
            let titleHeight = document.querySelectorAll(".realTime_title")[0].clientHeight;
            let  realTime_statistics =  document.querySelectorAll(".realTime_statistics")[0].clientHeight;
            document.querySelectorAll(".half_circle")[0].style.height =  halfPieStyle - titleHeight- 17 - 20 + 'px';
            document.querySelectorAll(".halfPieEcharts")[0].style.height = halfPieStyle - titleHeight - 17 - 20 + 'px';
            document.querySelectorAll(".halfPieEcharts")[1].style.height = halfPieStyle - titleHeight - 17 - 20 + 'px';
            document.querySelectorAll(".halfPieEcharts")[2].style.height = halfPieStyle - titleHeight - 17 - 20 + 'px';
            if(JSON.stringify(this.values) !== "{}")this.disposeAllChart();
        },
        initData() {
            var arr =[[0, '#1b5588'],[1, '#1b5588']];
            arr.splice(1, 0, this.col);
            let vue =this;
            this.halfPie_statistics.option = {
                // backgroundColor: '#00264d',
                series: [
                    {
                        type: 'gauge',
                        radius:'70%',
                        startAngle:'215',
                        endAngle:'-35',
                        splitNumber:'40',
                        pointer:{
                            show:false
                        },
                        detail: {
                            // offsetCenter:[0,9],  //大
                            offsetCenter:[0,3],
                                formatter: function (value) {
                                let numStr = value.toString()
                                // 十万以内直接返回
                                if (numStr.length < 6) {
                                    return numStr;
                                }else if (numStr.length > 8) {
                                    let decimal = numStr.substring(numStr.length - 8, numStr.length - 8);
                                    return parseFloat(parseInt(num / 100000000) + '.' + decimal);
                                }else if (numStr.length > 5) {
                                    let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
                                    return parseFloat(parseInt(num / 10000) + '.' + decimal);
                                }
                            },
                            fontSize:14,
                            color: '#fff'
                        },
                        data: [{
                                value: vue.showVal == -1?0:vue.showVal,
                                name: '数量',

                        }],
                        // pointer: {
                        //     width:1,
                        //     length: '80%',
                        //     color: 'rgba(255, 255, 255, 0.8)'
                        // },
                        title: [{
                            show: true,
                            // offsetCenter: [0, '20px'], //<!-- 【完成率】偏离中心的距离[左右,上下] -->
                            textStyle: {
                                color: '#fff',
                                // fontStyle: 'normal',
                                // fontWeight: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 30
                            }
                        }],
                        axisLine:{
                            show: true,
                            lineStyle: {
                                // color:[[0, '#1b5588'], [1, '#1b5588']].push([0.45, '#00ff00']),
                                color:arr,
                                width: 10,
                                shadowBlur: 15,
                                fontSize: 12,
                                // shadowColor: '#00ff00',
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                opacity: 1
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            length:10,
                            lineStyle: {
                                color: '#00377a',
                                width: 2,
                                type: 'solid',
                                shadowColor: '#00377a',
                                shadowBlur: 25,
                                shadowOffsetX: 10,
                                shadowOffsetY: 10,
                                opacity: 0.5
                            },
                        },
                        axisLabel: {
                            show: false
                        }
                    }
                ]
            };
            // if(this.halfPie_statistics.chart!=null&&this.halfPie_statistics.chart!=''&&this.halfPie_statistics.chart!=undefined){
            //     this.halfPie_statistics.chart.dispose();
            // }
            this.halfPie_statistics.chart = EChart.init(this.$refs.halfPie_statistics);
            this.halfPie_statistics.chart.resize();
            this.halfPie_statistics.chart.setOption(this.halfPie_statistics.option);
            window.addEventListener('resize', this.onWindowResize);

        },
        //释放图表，销毁对象
        disposeAllChart(){
            let i = 0 , len = this.chartArray.length
            for (;i < len; i++){
                let a = this.chartArray[i]
                if(this[a].chart){
                    this[a].chart.dispose()
                }
            }
            this.initData()
        }
    }
  }
</script>
<style lang="less" scoped>
.half_circle{
    width: 100%;
    height: calc(~'100% - ' 10px);
    position: relative;
    .halfPieEcharts{
        width: 100%;
        height: 100%;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/chart/half_circle.vue